import gql from 'graphql-tag';

export const Form = gql`
  query Form($organizationId: ID!, $formId: ID!) {
    organization(organizationId: $organizationId) {
      id
      form(formId: $formId) {
        id
        name
        formResponses {
          id
          submissionId
          status
          response
          errorMessage
          createdAt
          updatedAt
        }
      }
    }
  }
`;
